import { Member } from '@nextforce/api'
import { t } from 'app/i18l'
import { useRoutingContext } from 'app/routing_context'
import { useCreateDirectConversation } from 'chat/conversations/queries/create_direct'
import { useSearchRecipients } from 'chat/members/queries/recipients'
import React, { useCallback, useState } from 'react'
import { StatusBoundary } from 'shared/components/status_boundary'
import { useUser } from 'users/queries/detail'
import { ProcessingMemberListView } from '../views/processing_member_list'
import { RecipientsView } from './view'

export function RecipientsScreen() {
  const { data: user } = useUser()
  const { handleNavigation } = useRoutingContext()
  const [searchTerm, setSearchTerm] = useState<string>('')
  const searchRecipientsQuery = useSearchRecipients(searchTerm)

  const createDirectConversationMutation = useCreateDirectConversation()

  const onSendDirectMessage = useCallback(
    async (member: Member) => {
      const directConversation =
        await createDirectConversationMutation.mutateAsync(member.id)
      handleNavigation({
        routeName: 'conversations',
        routeParams: {
          screen:
            user?.role === 'observer' || user?.role === 'admin'
              ? 'dm'
              : 'allConversations',
        },
      })
      handleNavigation({
        routeName: 'messages',
        routeParams: {
          id: directConversation.id,
        },
      })
    },
    [createDirectConversationMutation, handleNavigation, user?.role]
  )

  if (searchRecipientsQuery.isLoading) {
    return <ProcessingMemberListView />
  }

  return (
    <StatusBoundary
      isLoading={
        !user ||
        searchRecipientsQuery.isLoading ||
        createDirectConversationMutation.isPending
      }
      error={
        searchRecipientsQuery.error ?? createDirectConversationMutation.error
      }
      loadingMessage={
        searchRecipientsQuery.isLoading
          ? t('loadingRecipientsText')
          : createDirectConversationMutation.isPending
          ? ''
          : undefined
      }
    >
      <RecipientsView
        disabledMemberIds={user ? [user.id] : []}
        recipients={searchRecipientsQuery.data}
        onMemberPress={onSendDirectMessage}
        searchText={searchTerm}
        setSearchText={setSearchTerm}
      />
    </StatusBoundary>
  )
}
